import React from "react";

import Dashboard from "../../components/dashboard";
import LayoutClients from "../../components/layout-clients";

const AfisofomDashboard = ({history}) => {

  return (
    <LayoutClients site="sofom" showPrincipalButton={false} history={history}>
      <Dashboard />
    </LayoutClients>
  );
};

export default AfisofomDashboard;
